import _ from "underscore";
import { dispatcher, DispatcherEvents } from "../../utils/dispatcher";
import { getCurrentVehicle } from "../../utils/device";
import { getServerDate } from "../../utils/storage/date";
import { IRawIoxData } from "../../services/ioxDataHandler";
import { MobileActions } from "../../store/mobile/actions";
import constants from "../../constants";
import pageHTML from "./ioxUsb.tmpl";
import { BaseCache, makeDeviceCache } from "../../utils/storage/cache";
import { Device } from "../../model/Device";
import DebugPageView from "./debugPageView";
let dInterval;

export default class IoxUsbView extends DebugPageView {
    private readonly template = _.template(pageHTML);
    private readonly deviceCache: BaseCache<IDevice | Device>;
    private readonly newLog: IRawIoxData = {
            latitude: 43.64969,
            longitude: -79.6065,
            driverId: (<any> this.app.userService.getCurrentUser()).id,
            engineHours: 0,
            odometer: 0,
            rpm: 3000,
            roadSpeed: 30,
            tripDuration: 655,
            tripOdometer: 0,
            vehicleId: -1,
            dateTime: getServerDate().toISOString(),
            status: "GPS Valid | IGN on | Engine Data | Date/Time Valid | Speed From Engine | Distance From GPS | ",
            rawData: [
                32, -14, -100, 36, 36, -29, 69, 28, 116, -31, 22, -73, 0, 46, 10, 117, -25, 68, 0, 63, 0, 0, 0, //junk
                0, 21, 57, 1, 0, -122, 1, 0, 0, -1, -1, -1, -1, 0, 0, 0, 0, //junk
                71, 55, 48, 48, 50, 48, 48, 48, 49, 48, 49, 48 // SERIAL NUMBER BYTES (active tracking)
            ]
    };

    constructor(options) {
        super(options);
        this.deviceCache = makeDeviceCache(options.app.store);
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #simulateD": this.simulateD,
            "click #simulateON": this.simulateON,
            "click #shortenONLogTimer": this.shortenONLogTimer,
            "click #simulateEnginePowerup": this.simulateEnginePowerup,
            "click #simulateEngineShutdown": this.simulateEngineShutdown,
            "click #simulateDataFromAssignedVehicle": this.simulateDataFromAssignedVehicle,
            "click #simulateDataFromUnassignedVehicle": this.simulateDataFromUnassignedVehicle,
            "click #simulateIoxUsbAttachment": this.simulateIoxUsbAttachment,
            "click #simulateIoxUsbDetachment": this.simulateIoxUsbDetachment,
            "click #stopSimulation": this.stopSimulation,
            "click #setOdometer": this.setOdometer,
            "click #setSerialNumber": this.setSerialNumber,
            "click #viewIncomingData": this.viewIncomingData,
            "click #hideIncomingData": this.hideIncomingData,
            "click #viewConnectionChange": this.viewConnectionChange,
            "click #hideConnectionChange": this.hideConnectionChange
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render() {
        this.el.innerHTML = this.template({

        });

        this.app.store.dispatch(MobileActions.setPageState({
            title: "IoxUsb",
            pageLevel: 2
        }));
        return this;
    }

    simulateD(): void {
        this.newLog.dateTime = Math.floor(Math.random() * 10) % 2 === 0 ? `${ getServerDate().getTime() }` : getServerDate().toISOString();
        this.newLog.roadSpeed  = 30;
        dInterval = setInterval(() => {
            dispatcher.trigger(DispatcherEvents.NewIoxData, this.newLog, false);
        }, 2000);
    }

    simulateON(): void {
        this.newLog.dateTime = Math.floor(Math.random() * 10) % 2 === 0 ? `${ getServerDate().getTime() }` : getServerDate().toISOString();
        this.newLog.roadSpeed = 0;
        clearInterval(dInterval);
        dispatcher.trigger(DispatcherEvents.NewIoxData, this.newLog, false);
    }

    shortenONLogTimer(): void {
        constants.HOS.CHECK_ON_LOG_INTERVAL = 1000; // 1 second
    }

    simulateEnginePowerup(): void {
        this.newLog.dateTime = Math.floor(Math.random() * 10) % 2 === 0 ? `${ getServerDate().getTime() }` : getServerDate().toISOString();
        this.newLog.roadSpeed = 0;
        this.newLog.status = "GPS Valid | IGN on | Engine Data | Date/Time Valid | Speed From Engine | Distance From GPS | ";
        dispatcher.trigger(DispatcherEvents.NewIoxData, this.newLog, false);
    }

    simulateEngineShutdown(): void {
        this.newLog.dateTime = Math.floor(Math.random() * 10) % 2 === 0 ? `${ getServerDate().getTime() }` : getServerDate().toISOString();
        this.newLog.roadSpeed = 0;
        this.newLog.status = "GPS Valid | IGN off | Engine Data | Date/Time Valid | Speed From Engine | Distance From GPS | ";
        dispatcher.trigger(DispatcherEvents.NewIoxData, this.newLog, false);
    }

    simulateDataFromAssignedVehicle(): void {
        let currentVehicle = getCurrentVehicle();
        if (!(currentVehicle && currentVehicle.id)) {
            return;
        }
        const populatedDevice = this.deviceCache.get({ id: currentVehicle.id })[0];
        let currSerialNumber = populatedDevice.serialNumber;
        if (currSerialNumber) {
            let serialBytes = this.strToUtf8Bytes(currSerialNumber);
            let rawData = [
                32, -14, -100, 36, 36, -29, 69, 28, 116, -31, 22, -73, 0, 46, 10, 117, -25, 68, 0, 63, 0, 0, 0, //junk
                0, 21, 57, 1, 0, -122, 1, 0, 0, -1, -1, -1, -1, 0, 0, 0, 0] // junk
                .concat(serialBytes);
            this.newLog.rawData = rawData;
        }
    }

    simulateDataFromUnassignedVehicle(): void {
        this.newLog.vehicleId = 20001010;
    }

    setSerialNumber(): void {
        let enteredSerialNumberElement: any = document.getElementById("enteredSerialNumber");
        if (enteredSerialNumberElement && enteredSerialNumberElement.value) {
            let serialBytes = this.strToUtf8Bytes(enteredSerialNumberElement.value);
            let rawData = [
                32, -14, -100, 36, 36, -29, 69, 28, 116, -31, 22, -73, 0, 46, 10, 117, -25, 68, 0, 63, 0, 0, 0, //junk
                0, 21, 57, 1, 0, -122, 1, 0, 0, -1, -1, -1, -1, 0, 0, 0, 0] // junk
                .concat(serialBytes);
            this.newLog.rawData = rawData;
        }
    }

    simulateIoxUsbAttachment(): void {
        dispatcher.trigger(DispatcherEvents.IoxAttached, true);
    }

    simulateIoxUsbDetachment(): void {
        dispatcher.trigger(DispatcherEvents.IoxAttached, false);
    }

    stopSimulation(): void {
        clearInterval(dInterval);
    }

    setOdometer(): void {
        let enteredOdometerElement: any = document.getElementById("enteredOdometer");
        if (enteredOdometerElement &&  enteredOdometerElement.value) {
            this.newLog.odometer = parseInt(enteredOdometerElement.value);
        }
    }

    viewIncomingData(): void {
        this.listenTo(dispatcher, DispatcherEvents.NewIoxData, this.displayData.bind(this));
    }

    hideIncomingData(): void {
        this.stopListening(dispatcher, DispatcherEvents.NewIoxData);
        let ioxDataTableElement = <HTMLTableElement>document.getElementById("iox-logs-output");
        ioxDataTableElement.innerHTML = "";
    }

    displayData(ioxData): void {
        let logsTableElement = <HTMLTableElement>document.getElementById("iox-logs-output");
        for (let key in ioxData) {
            logsTableElement.insertRow(0).innerHTML = key + ": " + JSON.stringify(ioxData[key]);
        }
        logsTableElement.insertRow(0).innerHTML = "<hr>";
    }

    viewConnectionChange(): void {
        this.listenTo(dispatcher, DispatcherEvents.IoxAttached, this.displayConnectionChange.bind(this));
    }

    hideConnectionChange(): void {
        this.stopListening(dispatcher, DispatcherEvents.IoxAttached);
        let ioxAttachTableElement = <HTMLTableElement>document.getElementById("iox-connection-change");
        ioxAttachTableElement.innerHTML = "";
    }

    displayConnectionChange(ioxAttach: boolean): void {
        let ioxAttachTableElement = <HTMLTableElement>document.getElementById("iox-connection-change");
        let row = ioxAttachTableElement.insertRow(0);
        row.innerHTML = "<hr>" + "Cable attached: " + ioxAttach.toString();
    }

    /**
     * Transforms and returns a string in it's UTF-8 byte array representation.
     * https://stackoverflow.com/a/51904484
     * @param stringToParse The string we want as a UTF-8 byte array
     * @returns UTF-8 byte array representation of the provided string
     */
    strToUtf8Bytes(stringToParse: string): number[] {
        const utf8: number[] = [];

        for (let i = 0; i < stringToParse.length; i++) {
            let charCode = stringToParse.charCodeAt(i);
            if (charCode < 0x80) {
                utf8.push(charCode);
            } else if (charCode < 0x800) {
                utf8.push(0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f));
            } else if (charCode < 0xd800 || charCode >= 0xe000) {
                utf8.push(0xe0 | (charCode >> 12), 0x80 | ((charCode >> 6) & 0x3f), 0x80 | (charCode & 0x3f));
            } else {
                i++;
                // Surrogate pair:
                // UTF-16 encodes 0x10000-0x10FFFF by subtracting 0x10000 and
                // splitting the 20 bits of 0x0-0xFFFFF into two halves
                charCode = 0x10000 + (((charCode & 0x3ff) << 10) | (stringToParse.charCodeAt(i) & 0x3ff));
                utf8.push(
                    0xf0 | (charCode >> 18),
                    0x80 | ((charCode >> 12) & 0x3f),
                    0x80 | ((charCode >> 6) & 0x3f),
                    0x80 | (charCode & 0x3f)
                );
            }
        }
        return utf8;
    }
}